class VideoTranscript extends HTMLElement {
  connectedCallback() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.init(), {
        once: true,
      });
    } else {
      this.init();
    }
  }

  init() {
    this.toggleBtn = this.querySelector("[data-transcript-toggle]");
    this.panel = this.querySelector("[data-transcript-panel]");
    this.backdrop = this.querySelector("[data-transcript-backdrop]");
    this.closeBtn = this.querySelector("[data-transcript-close]");
    this.label = this.querySelector("[data-transcript-label]");
    this.scroller = this.querySelector("[data-transcript-scroll]");

    if (!this.toggleBtn || !this.panel) return;

    this.openLabel = this.label ? this.label.textContent.trim() : "";
    this.closeLabel = "Hide Transcript";

    this.toggleBtn.addEventListener("click", () => this.toggle());

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", () => this.close());
    }

    if (this.backdrop) {
      this.backdrop.addEventListener("click", () => this.close());
      this.backdrop.addEventListener(
        "touchmove",
        (e) => e.preventDefault(),
        { passive: false }
      );
    }

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen()) this.close();
    });
  }

  isMobile() {
    return window.matchMedia("(max-width: 1023px)").matches;
  }

  isOpen() {
    return this.panel.hasAttribute("data-open");
  }

  toggle() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.panel.setAttribute("data-open", "");
    this.toggleBtn.setAttribute("aria-expanded", "true");

    if (this.label && !this.isMobile()) {
      this.label.textContent = this.closeLabel;
    }

    if (this.isMobile()) {
      if (this.backdrop) this.backdrop.setAttribute("data-open", "");
      if (this.scroller) this.scroller.scrollTop = 0;
      if (this.closeBtn) this.closeBtn.focus({ preventScroll: true });
    }
  }

  close() {
    this.panel.removeAttribute("data-open");
    this.toggleBtn.setAttribute("aria-expanded", "false");

    if (this.label) {
      this.label.textContent = this.openLabel;
    }

    if (this.backdrop) this.backdrop.removeAttribute("data-open");
  }
}

customElements.define("video-transcript", VideoTranscript);
